<!-- Center canvas: summary, text typed into directly, matches Main Banner/Intro + CTA's badge+card pattern -->
<div
  class="cr-hd-card"
  *ngIf="isPreview"
  [id]="block.blockId"
>
  <span class="cr-hd-badge">Big Headline</span>

  <span
    class="cr-hd-value"
    [appInlineEdit]="block.variables?.Heading ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert headline here"
    (inlineEditChange)="onChange($event, 'Heading')"
  ></span>
</div>

<!-- Right panel: real edit form -->
<div class="cr-hd-edit" *ngIf="!isPreview">
  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.Heading ?? ''"
    (handleOnChange)="onChange($event, 'Heading')"
    [placeholder]="headingPlaceholder"
    [maxLength]="500"
    variable="Heading"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
